import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    description: {
        id: '_.home_screen_banner.description',
        defaultMessage:
            "You can add this site to your mobile device's home screen for easy access to your online account."
    },
    linksDescription: {
        id: '_.home_screen_banner.links_description',
        defaultMessage:
            'Need a hand? Click {iOSLink} for iOS or {androidLink} for Android.'
    },
    linkText: {
        id: '_.home_screen_banner.link_text',
        defaultMessage: 'here'
    }
});
